import React, { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import ErrorLoading from './ErrorLoading'
import Dashboard from './Dashboard'
import Loading from './Loading'
import { useRefetch } from '../../../hooks/useRefetch'
import { MEMBERSHIP_JOURNEY_QUERY } from '../../queries/member'
import { COACH_TOOLS_API } from '../../../apolloClient'
import { transformJourneyData } from './utils'
import { REQUIREMENT_DATA } from './requirementData'

export const MembershipJourneyDashboardWrapper = ({ authReady, onEditProfile, history }) => {
  const { isFetching, reload } = useRefetch()

  const { data, loading, error, refetch } = useQuery(MEMBERSHIP_JOURNEY_QUERY, {
    context: {
      api: COACH_TOOLS_API
    },
    skip: !authReady,
    fetchPolicy: 'cache-and-network'
  })

  const levelState = useMemo(() => {
    if (!data || !data.me) return null
    return transformJourneyData(data, REQUIREMENT_DATA)
  }, [data])

  if (!authReady || loading || isFetching) {
    return <Loading />
  }
  
  if (error || !levelState || !data?.me) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  const mockAnnouncements = [
    {
      id: '1',
      title: 'Contribute to the Medical & Disaster Relief Fund Today',
      body: 'This essential fund supports PGA of America Members during natural disasters and serious medical emergencies.',
      isNew: true
    },
    {
      id: '2',
      title: 'PGA HOPE Certification Training',
      body: 'PGA HOPE Certification training has opportunities across the country to become trained in adaptive golf and military cultural competency.',
      isNew: true
    }
  ]

  return (
    <Dashboard
      me={data.me}
      levelState={levelState}
      programHistory={data.me.educationPgmProgramHistory || []}
      prospect={data.me.prospect}
      onEditProfile={onEditProfile}
      history={history}
      announcements={mockAnnouncements}
    />
  )
}

export default MembershipJourneyDashboardWrapper
